import { PaymentMethods } from '@/types/types';

export const paymentMethods: PaymentMethods[] = [
  {
    name: 'Karta kredytowa',
    imageUrl:
      'https://www.przelewy24.pl/themes/przelewy24/assets/img/metody-platnosci/glowne/karty.svg?26092022',
    paymentMethod: 'card',
  },
  {
    name: 'Przelewy24',
    imageUrl:
      'https://www.przelewy24.pl/themes/przelewy24/assets/img/base/przelewy24_logo_2022.svg',
    paymentMethod: 'p24',
  },
  {
    name: 'GooglePay',
    imageUrl:
      'https://www.przelewy24.pl/themes/przelewy24/assets/img/metody-platnosci/glowne/googlepay.svg',
    paymentMethod: 'googlepay',
  },
  {
    name: 'ApplePay',
    imageUrl: 'https://woocommerce.pl/wp-content/uploads/2021/06/pay-apple.png',
    paymentMethod: 'applepay',
  },
  {
    name: 'Blik',
    imageUrl:
      'https://www.przelewy24.pl/themes/przelewy24/assets/img/metody-platnosci/glowne/blik.svg',
    paymentMethod: 'blik',
  },
];
